export default {
  goalsList: [],
  initialGoalData: {},
  initialFpId: '',
  currentGoalIndex: 0,
};
